import { defaultField, defaultBooleanField, defaultPercentField } from "helpers/row-logic-helper";
import moment from "moment";
import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";

import { shouldShowField } from "../loanDetailEditUtil";

import {
  shouldShowPrepaymentType,
  shouldShowExitFee,
  shouldShowLockoutPeriod,
  shouldShowNoticePeriod,
  shouldShowParPrepaymentPeriod,
  shouldShowSpreadMaintenancePeriod,
  shouldShowYieldMaintenancePeriod,
  shouldShowMakeWholePeriod,
  shouldShowSuccessorBorrowerDesignation,
  shouldShowCalculationMethodology,
  shouldShowReinvestmentRateAssumptions,
  shouldShowPVRateAssumptions,
  shouldShowDefeasanceCollateral,
  shouldShowSecuritiesStructure,
  shouldShowPortfolioMaturity,
  shouldShowDefeasanceFee,
  shouldShowSecuritization,
  shouldShowOther
} from "./section-details-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  prepaymentType: {
    isVisible: data => shouldShowPrepaymentType(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Prepayment Type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: loan => defaultField(loan, "prepaymentTerms.prepaymentType.value"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.prepaymentType"
      }
    ]
  },
  exitFee: {
    isVisible: data => shouldShowExitFee(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Exit fee",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT_SUBTEXT,
        map: data => defaultPercentField(data, "prepaymentTerms.exitFee", 100),
        decimals: 2,
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.exitFee"
      }
    ]
  },
  lockoutPeriod: {
    isVisible: data => shouldShowLockoutPeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Lockout period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.lockoutPeriod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.lockoutPeriod"
      }
    ]
  },
  parPrepaymentPeriod: {
    isVisible: data => shouldShowParPrepaymentPeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Par prepayment period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.parPrepaymentPeriod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.parPrepaymentPeriod"
      }
    ]
  },
  spreadMaintenancePeriod: {
    isVisible: data => shouldShowSpreadMaintenancePeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Spread Maintenance Period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.spreadMaintenance"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.spreadMaintenance"
      }
    ]
  },
  noticePeriod: {
    isVisible: data => shouldShowNoticePeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Notice Period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.noticePeriod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.noticePeriod"
      }
    ]
  },
  yieldMaintenancePeriod: {
    isVisible: data => shouldShowYieldMaintenancePeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Yield Maintenance Period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.yieldMaintenancePeriod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.yieldMaintenancePeriod"
      }
    ]
  },
  makeWholePeriod: {
    isVisible: data => shouldShowMakeWholePeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Make Whole Period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.makeWholePeriod"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.makeWholePeriod"
      }
    ]
  },
  successorBorrowerDesignation: {
    isVisible: data => shouldShowSuccessorBorrowerDesignation(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Successor Borrower Designation",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.successorBorrowerDesignation"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.successorBorrowerDesignation"
      }
    ]
  },
  calculationMethodology: {
    isVisible: data => shouldShowCalculationMethodology(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Calculation Methodology",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.calculationMethodology"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.calculationMethodology"
      }
    ]
  },
  reinvestmentRateAssumptions: {
    isVisible: data => shouldShowReinvestmentRateAssumptions(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Reinvestment Rate Assumptions",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.reinvestmentRateAssumption"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.reinvestmentRateAssumption"
      }
    ]
  },
  pvRateAssumptions: {
    isVisible: data => shouldShowPVRateAssumptions(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "PV Rate Assumptions",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.pvRateAssumption"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.pvRateAssumption"
      }
    ]
  },
  defeasanceCollateral: {
    isVisible: data => shouldShowDefeasanceCollateral(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Defeasance Collateral",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.defeasanceCollateral"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.defeasanceCollateral"
      }
    ]
  },
  securitiesStructure: {
    isVisible: data => shouldShowSecuritiesStructure(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Securities Structure",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.securitiesStructure"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.securitiesStructure"
      }
    ]
  },
  portfolioMaturity: {
    isVisible: data => shouldShowPortfolioMaturity(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Portfolio Maturity",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.portfolioMaturity"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.portfolioMaturity"
      }
    ]
  },
  defeasanceFee: {
    isVisible: data => shouldShowDefeasanceFee(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Defeasance Fee",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR_SUBTEXT,
        map: data => defaultField(data, "prepaymentTerms.defeasanceFee"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.defeasanceFee"
      }
    ]
  },
  securitization: {
    isVisible: data => shouldShowSecuritization(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Securitization",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN_SUBTEXT,
        map: data => {
          const isSecuritized = defaultBooleanField(data, "prepaymentTerms.isSecuritized");
          if (isSecuritized === "--") {
            return false;
          }

          return isSecuritized;
        },
        Cell: tableSideColumnMapper,
        subtextMappers: [
          {
            map: data => {
              const isSecuritized = defaultBooleanField(data, "prepaymentTerms.isSecuritized");
              if (isSecuritized === "--") {
                return null;
              }
              const securitizationDate = isSecuritized ? defaultField(data, "prepaymentTerms.securitizationDate") : null;

              return isSecuritized ? moment(securitizationDate).format("MMMM YYYY") : "--";
            }
          }
        ]
      }
    ]
  },
  other: {
    isVisible: data => shouldShowOther(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Other",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "prepaymentTerms.other"),
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.REFERENCE,
        Cell: tableSideColumnMapper,
        referencedFieldPath: "loans.prepaymentTerms.other"
      }
    ]
  }
};
